import axiosInstance from './base.api';
import { getEnvironmentVariable } from '../utils';

export interface JWTResponseDTO {
    token: string;
    user: {
        id: string;
        username: string;
        role: 'patient' | 'manager' | 'doctor' | 'admin';
        email: string;
        date_created: number;
        last_login: number | null;
        expertise: string | null;
        image: string | null;
        description: number | null;
        created_at: number | null;
        updated_at: number | null;
    };
}

interface JWTValidateResponseDTO {
    valid: boolean;
    payload: {};
}

export const getReactToken = async (): Promise<{
    token: string;
    userInfo: JWTResponseDTO['user'];
}> => {
    const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
    const response = await axiosInstance.post<JWTResponseDTO>(`${platformURL}/JWT/react/login`);

    return {
        token: response.data.token,
        userInfo: response.data.user,
    };
};

// const tokenHeaderNames = {
//     sessionToken: 'AuthorizationUser',
//     reactToken: 'AuthorizationReact',
// };
export const validateToken = async (token: string): Promise<boolean> => {
    const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
    const response = await axiosInstance.get<JWTValidateResponseDTO>(`${platformURL}/JWT/validate`, {
        headers: {
            AuthorizationUser: token,
        },
    });
    return response.data.valid;
};

export const logoutSession = async (): Promise<void> => {
    const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
    await axiosInstance.post<JWTResponseDTO>(`${platformURL}/logout`);
};

// export const getSessionToken = async (): Promise<{
//     token: string;
//     userInfo: JWTResponseDTO['user'];
// }> => {
//     const session = getCookie('session_for_front');
//     const encodedToken = encodeURIComponent(session);
//     const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
//     const response = await axiosInstance.post(`${platformURL}/JWT/session/login?session=${encodedToken}`);
//
//     return {
//         token: response.data.token,
//         userInfo: response.data.user,
//     };
// };
